import { GetImagePropertiesTypes } from "@website/utils/get-image/get-image.types";
import trimStart from "lodash-es/trimStart";

export const getImage = ({ width, height, src }: GetImagePropertiesTypes) => {
  if (!src) return "";
  const isResized = /\/\d+x\d+\//.test(src);
  const isAbsoluteUrl = /^https?:\/\//.test(src);
  const isStore = /(villa|int-hotel|domestic-hotel)\//.test(src);
  const sizeSegment = width && height ? `${width}x${height}/` : "";

  const replaced = src.replace(
    /\/(villa|int-hotel|domestic-hotel)\//,
    (_match, segment) => `/${segment}/${sizeSegment}`
  );

  if (isResized) return src;
  if (isAbsoluteUrl) return replaced;

  if (isStore) {
    return `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/${trimStart(
      replaced,
      "/"
    )}`;
  }

  return `${
    process.env.NEXT_PUBLIC_BASE_URL_IMAGES
  }/images/${sizeSegment}${trimStart(src, "/")}`;
};
